import { CustomerTestGroup } from '../../../core/models/customer-test-group.model';
import { CustomerStoreService } from '../../../core/services/customer-store.service';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap, take, tap } from 'rxjs/operators';
import { AnalyticsEvent, AnalyticsService } from 'src/app/core/services/analytics-service';
import { OnboardingService } from '../../../onboarding/services/onboarding.service';
import { IEmailVerificationForm } from '../../interfaces/auth.interface';
import { VerifiedEmail } from '../../../auth/model/email-verification-token.model';
import { AuthStoreService } from './auth-store.service';
import { RegistrationService } from './registration.service';
import { Group } from 'src/app/core/models/customer-test-group.model';
import { TypeformService } from 'src/app/shared/services/typeform.service';

@Injectable({
  providedIn: 'root',
})
export class EmailVerificationService {
  constructor(
    private router: Router,
    private authStore: AuthStoreService,
    private customerStoreService: CustomerStoreService,
    private onboardingStoreService: OnboardingService,
    private analyticsService: AnalyticsService,
    private registrationService: RegistrationService,
    private typeformService: TypeformService,
  ) {
  }

  public redirectAfterEmailVerification(): void {
    if (this.authStore.payByLink) {
      this.onboardingStoreService
        .skip()
        .subscribe();
    } else {
      this.customerStoreService
        .loadCustomer(this.authStore.userInfo.customer_id)
        .pipe(
          take(1),
          tap((customer) => this.navigateByMgmTestGroup(customer.testGroup)),
        )
        .subscribe();
    }
  }

  public trackVerificationStartedEvent(): void {
    this.analyticsService.trackEvent(new AnalyticsEvent('Customer Email Address Verification Started'));
  }

  public verify(formData: IEmailVerificationForm): Observable<VerifiedEmail> {
    return this.authStore.verifyEmail(formData).pipe(
      tap(() => {
        this.trackEventsForCompletedRegistration();
      }),
    );
  }

  private trackEventsForCompletedRegistration(): void {
    this.analyticsService.trackLogin();
    this.analyticsService.trackEvent(new AnalyticsEvent('Customer Email Address Verified'), true);
    this.registrationService.trackRegistrationEvent('Customer Registration Completed');
  }

  private navigateByMgmTestGroup(testGroup: CustomerTestGroup) {
    testGroup.mgmTestGroup === Group.GROUP_A ? this.navigateToOnboarding() : this.navigateToEmptyCart();
  }

  private navigateToOnboarding() {
    this.router.navigateByUrl('/onboarding').then(() => this.showOnboardingQuestionnaireForGroup());
  }

  private navigateToEmptyCart() {
    this.onboardingStoreService
      .skip()
      .pipe(
        switchMap(() =>
          this.router.navigateByUrl('/liabilities/pay').then(() => this.showOnboardingQuestionnaireForGroup()),
        ),
        take(1),
      )
      .subscribe();
  }

  public showOnboardingQuestionnaireForGroup(): void {
    this.typeformService.showOnboardingQuestionnaire();
  }
}
